import { render, staticRenderFns } from "./PrescriptionInfoPage.vue?vue&type=template&id=c13b4c1c&scoped=true"
import script from "./PrescriptionInfoPage.vue?vue&type=script&lang=js"
export * from "./PrescriptionInfoPage.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionInfoPage.vue?vue&type=style&index=0&id=c13b4c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b4c1c",
  null
  
)

export default component.exports